import { store } from '../../store';
import { addWhiteboardFileAsJSON, addWhiteboardUploadedOfficeFiles, setWhiteboardCurrentPage, updateExcalidrawElements, updateMouseAppStateChanges, updateMousePointerLocation, } from '../../store/slices/whiteboard';
import { DataMsgBodyType, } from '../proto/plugnmeet_datamessage_pb';
export const handleWhiteboardMsg = (body) => {
    var _a, _b;
    const isPresenter = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_presenter;
    if (body.type === DataMsgBodyType.SCENE_UPDATE) {
        store.dispatch(updateExcalidrawElements(body.msg));
    }
    else if (body.type === DataMsgBodyType.POINTER_UPDATE) {
        store.dispatch(updateMousePointerLocation(body.msg));
    }
    else if (body.type === DataMsgBodyType.ADD_WHITEBOARD_FILE) {
        store.dispatch(addWhiteboardFileAsJSON(body.msg));
    }
    else if (body.type === DataMsgBodyType.PAGE_CHANGE) {
        if (!isPresenter) {
            store.dispatch(setWhiteboardCurrentPage(Number(body.msg)));
        }
    }
    else if (body.type === DataMsgBodyType.ADD_WHITEBOARD_OFFICE_FILE) {
        handleAddWhiteboardOfficeFile(body.msg);
    }
    else if (body.type === DataMsgBodyType.WHITEBOARD_APP_STATE_CHANGE) {
        if (!isPresenter) {
            store.dispatch(updateMouseAppStateChanges(JSON.parse(body.msg)));
        }
    }
};
const handleAddWhiteboardOfficeFile = (msg) => {
    const newFile = JSON.parse(msg);
    store.dispatch(addWhiteboardUploadedOfficeFiles(newFile));
};
